import { render, staticRenderFns } from "./about-you.vue?vue&type=template&id=6f38d584&scoped=true&"
import script from "./about-you.vue?vue&type=script&lang=js&"
export * from "./about-you.vue?vue&type=script&lang=js&"
import style0 from "./about-you.vue?vue&type=style&index=0&id=6f38d584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f38d584",
  null
  
)

component.options.__file = "about-you.vue"
export default component.exports